<button id="btnConfirmationModalOpen" data-toggle="modal" data-target="#ConfirmationModal" class="d-none"></button>

<div class="modal fade" id="ConfirmationModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style="z-index: 999999;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">{{ConfirmationService.Title}}</h5>
          <button type="button" class="close" data-toggle="modal" data-target="#ConfirmationModal" aria-label="Close" (click)="ConfirmationService.ResetDialogue()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" [innerHtml]="ConfirmationService.Message"></div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="ConfirmationService.OnSuccess()">{{ ConfirmationService.Action }}</button>
          <button id="btnConfirmationModalClose" type="button" class="btn btn-secondary" data-toggle="modal" data-target="#ConfirmationModal" (click)="ConfirmationService.ResetDialogue()">Cancel</button>
        </div>
      </div>
    </div>
  </div>